import React from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import { ViewProps } from './View';

const Loading = ({ loading }: ViewProps) => loading ? <LinearProgress variant="indeterminate" color="primary"/> : null;

const mapStateToProps = state => ({ loading: state.loading });
export default connect(mapStateToProps)(Loading);
